// 获取浏览器宽高
export function getWinW() {
	return document.documentElement.clientWidth
}
export function getWinH() {
	return document.documentElement.clientHeight
}

export function hasClass(el, className) {
	let reg = new RegExp('(^|\\s+)'+ className + '(\\s+|$)')
	return reg.test(el.className)
}

export function addClass(el, className) {
	if(hasClass(el, className)){
		return
	}
	let newClass = el.className.split(' ')
	newClass.push(className)
	el.className = newClass.join(' ')
}



// WEBPACK FOOTER //
// ./src/util/dom.js